import { lazy } from 'react';

export const CheckoutPage = lazy(
  () =>
    import(
      /* webpackPreload: true */
      /* webpackChunkName: "CheckoutPage" */
      './CheckoutPage'
    ),
);
